module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8n9r2n5r-83c7048cdbe7140f72a9346a7a85727d.svg";